import React from 'react';
import { RiderDeductionInfo } from '../types/riderInfoDetail.types';
import '../styles/DeductionTable.css';
import {
    DEDUCTION_TABLE_COLUMNS,
    DEDUCTION_COLUMN_COUNT,
    formatCurrency,
} from '../utils/riderInfoDetailHelpers';

interface DeductionTableProps {
    deductions: RiderDeductionInfo[];
}

const DeductionTable: React.FC<DeductionTableProps> = ({ deductions }) => {
    return (
        <div className="section-margin">
            <div className="detail-card">
                <div className="detail-card-header">
                    <i className="fas fa-list-alt card-icon" />
                    <h3 className="card-title">일차감 정보</h3>
                </div>
                <div className="deduction-table-wrapper">
                    <table className="deduction-table">
                        <thead>
                        <tr>
                            {DEDUCTION_TABLE_COLUMNS.map((column) => (
                                <th key={column}>{column}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {deductions.length === 0 ? (
                            <tr>
                                <td colSpan={DEDUCTION_COLUMN_COUNT} className="deduction-empty-state">
                                    <i className="fas fa-inbox deduction-empty-icon" />
                                    <span className="deduction-empty-text">일차감 정보가 없습니다.</span>
                                </td>
                            </tr>
                        ) : (
                            deductions.map((deduction, index) => (
                                <tr key={deduction.id}>
                                    <td>{index + 1}</td>
                                    <td>{deduction.name}</td>
                                    <td>{formatCurrency(deduction.amount)}</td>
                                    <td>{deduction.startDate}</td>
                                    <td>{deduction.endDate}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DeductionTable;
